<app-breadcrumb [title]="'Grievance'"></app-breadcrumb>
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="py-1 px-3">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group form-focus">
                <label class="focus-label fw-bold mb-2 ">Search Keyword</label>
                <input type="text" class="form-control floating" [(ngModel)]="query.refNo" placeholder="Search User Ref"
                  id="refNo">
              </div>
            </div>
            <div class="col-md-2">
              <label class="focus-label fw-bold mb-2">Query Type</label>
              <div class="form-group form-focus select-focus">
                <select [(ngModel)]="query.isActive" class="form-select form-control" for="isActive" name="isActive">
                  <option value="" selected>--SELECT--</option>
                  <option *ngFor="let item of returTypes" value="{{ item.value }}">{{ item.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group form-focus">
                <label class="focus-label fw-bold mb-2">From</label>
                <input [(ngModel)]="query.createdFrom" (ngModelChange)="changeCreatedDateEvent($event)"
                  [minDate]="fromMinDate" [maxDate]="fromMaxDate" class="form-control  datepicker" for="postedFrom"
                  name="postedFrom" placeholder="Request From" ngbDatepicker #postedFrom="ngbDatepicker"
                  (click)="postedFrom.toggle()" />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group form-focus">
                <label class="focus-label fw-bold mb-2">To</label>
                <input [(ngModel)]="query.createdTo" [minDate]="toMinDate" [maxDate]="toMaxDate"
                  class="form-control  datepicker" for="postedTill" name="postedTill" placeholder="Request To"
                  ngbDatepicker #postedTill="ngbDatepicker" (click)="postedTill.toggle()" />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group form-focus select-focus">
                <label class="focus-label fw-bold mb-2">Status Type</label>
                <select [(ngModel)]="query.status" class="form-select form-control" for="status" name="status">
                  <option value="" selected>--SELECT--</option>
                  <option value="1">Pending</option>
                  <option value="2">Closed</option>
                  <!-- <option value="3">Recall</option> -->
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group d-flex justify-content-end  mt-4">
                <button class=" m-2 mt-0 btn btn-success" (click)="filter()">Search</button>
                <button type="button" class="m-2 mt-0 btn btn-primary" (click)="resetClick()">Reset</button>
              </div>
            </div>
          </div>
          <div class="row">
          </div>
        </div>
      </div>
      <div class="row p-2">
        <div class="d-flex justify-content-end">
        </div>
        <div class="col-md-12">
          <div class="col-md-12">
            <table class="table table-striped custom-table mb-0 datatable">
              <colgroup>
                <col style="width: 10%">
                <col style="width: 10%">
                <col style="width: 10%">
                <col style="width: 20%">
                <col style="width: 30%">
                <col style="width: 5%">
                <col style="width: 8%">
              </colgroup>
              <thead class="table-light">
                <tr>
                  <th class="" *ngFor="let c of columns">
                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                      <div class="d-flex justify-content-between align-items-center">
                        {{ c.title }}
                        <div class="ml-2">
                          <i-bs *ngIf="query.sort === c.key"
                            [name]="query.sortDir == 'Ascending' ? 'arrow-up' : 'arrow-down'"></i-bs>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                      {{ c.title }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of queryResult.items;let indexOfelement=index;">
                  <td>{{ item.refNo}}</td>
                  <td>{{ item.profile?.applicationUser?.shalaId}}</td>
                  <td>{{ item.createdAt | date }}</td>
                  <td>{{ item.profile?.firstName +' '+ item?.profile?.middleName +'
                    '+item?.profile?.lastName }}</td>
                  <td>{{ item.grievanceTypes?.name }}</td>
                  <td>
                    <span *ngIf="item.statusId==1" class="badge bg-warning">Pending</span>
                    <span *ngIf="item.statusId==3" class="badge bg-success">Recall</span>
                    <span *ngIf="item.statusId==2" class="badge bg-danger">Closed</span>
                  </td>
                  <td>
                    <div ngbDropdown class="d-inline-block" style="background-color: #f3e8e8;">
                      <button class="btn btn-outline-danger" ngbDropdownToggle>Action</button>
                      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="background-color: #f3e8e8;">
                        <button ngbDropdownItem (click)="onViewSubmission(item.id)">View
                          Grievance</button>
                        <ng-container *ngIf="item.statusId==1">
                          <button ngbDropdownItem (click)="onClose(closeComment, 2,item.id)">Close Grievance</button>
                        </ng-container>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <em>
            <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
            </pagination>
          </em>
        </div>
      </div>
    </div>
  </div>
</div>



<ng-template #closeGrevance let-modal>
  <div class="modal-header text-white bg-them-danger-1 rounded p-2">
    <div class="d-flex justify-content-between align-items-center w-100 ">
      <h4 class="h5 fw-bold">
        <div>
          <div>Comments</div>
        </div>
      </h4>
      <button type="button" class="btn btn-link shadow-none px-0 text-white text-bold" (click)="close()">
        <i-bs name="x"></i-bs>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="row px-lg-4">
      <div class="col-lg-12 p-3">
        <form [formGroup]="closeGrievanceForm" (ngSubmit)="submit()">
          <input type="hidden" formControlName="userMasterId">
          <input type="hidden" formControlName="status">
          <div class="form-group mb-3">
            <label class="form-label" for="closeComment">Comments<small class="text-danger">*</small></label>
            <textarea MyInput formControlName="closeComment" rows="4" class="form-control"></textarea>
            <my-error controlName="closeComment" errorKey="required">Comments is required.</my-error>
          </div>
          <div class="d-flex justify-content-center mt-5">
            <button class="btn  btn-theme-alternate-1 rounded-3  border-2 m-1 px-3"
              [disabled]="!closeGrievanceForm.valid || loading" type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Submit
            </button>
            <button class="btn btn-outline-dark rounded-3 border-2 m-1 px-3" type="button" (click)="close()">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #closeComment let-modal>
  <div class="modal-header text-white bg-them-danger-1 rounded p-2">
    <div class="d-flex justify-content-between align-items-center w-100 ">
      <h4 class="h5 fw-bold text-danger text-center">
        <div>
          <div>Comment</div>
        </div>
      </h4>
      <button type="button" class="btn btn-link shadow-none px-0 text-white text-bold" (click)="close()">
        <i-bs name="x"></i-bs>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="row px-lg-4">
      <div class="col-lg-12 p-3">
        <form [formGroup]="closeGrievanceForm" (ngSubmit)="submit()">
          <input type="hidden" formControlName="userMasterId">
          <input type="hidden" formControlName="status">
          <div class="form-group mb-3">
            <label class="form-label " for="closeComment">Comments<small class="text-danger">*</small></label>
            <textarea MyInput formControlName="closeComment" rows="4" class="form-control"></textarea>
            <my-error controlName="closeComment" errorKey="required">Comments is required.</my-error>
          </div>
          <div class="d-flex justify-content-center mt-5">
            <button class="btn  bg-primary text-white rounded-3  border-2 m-1 px-3"
              [disabled]="!closeGrievanceForm.valid || loading" type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Submit
            </button>
            <button class="btn btn-outline-dark rounded-3 border-2 m-1 px-3" type="button" (click)="close()">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #closeGrevance let-modal>
  <div class="modal-header text-white bg-them-danger-1 rounded p-2">
    <div class="d-flex justify-content-between align-items-center w-100 ">
      <h4 class="h5 fw-bold">
        <div>
          <div>Comments</div>
        </div>
      </h4>
      <button type="button" class="btn btn-link shadow-none px-0 text-white text-bold" (click)="close()">
        <i-bs name="x"></i-bs>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="row px-lg-4">
      <div class="col-lg-12 p-3">
        <form [formGroup]="closeGrievanceForm" (ngSubmit)="submit()">
          <input type="hidden" formControlName="userMasterId">
          <input type="hidden" formControlName="status">
          <div class="form-group mb-3">
            <label class="form-label" for="closeComment">Comments<small class="text-danger">*</small></label>
            <textarea MyInput formControlName="closeComment" rows="4" class="form-control"></textarea>
            <my-error controlName="closeComment" errorKey="required">Comments is required.</my-error>
          </div>
          <div class="d-flex justify-content-center mt-5">
            <button class="btn  bg-primary text-white rounded-3  border-2 m-1 px-3"
              [disabled]="!closeGrievanceForm.valid || loading" type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Submit
            </button>
            <button class="btn btn-outline-dark rounded-3 border-2 m-1 px-3" type="button" (click)="close()">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>